// Display-name helper — FE-033.
//
// Pure formatter shared by MostOverdueSection and
// EmployeePerformanceSection. Prefers ``display_name`` (set by the
// backend's user-profile resolver), falls back to ``email``, and
// finally to a short prefix of the UUID so even the rawest payload
// renders something readable.
//
// No network call: callers pass the per-row data already in hand
// from the BE-029 response contract.

export interface StaffNameLike {
  user_id: string;
  display_name?: string | null;
  email?: string | null;
}

export function formatStaffName(row: StaffNameLike): string {
  const display = (row.display_name ?? "").trim();
  if (display) return display;
  const email = (row.email ?? "").trim();
  if (email) return email;
  return shortenUserId(row.user_id);
}

export function shortenUserId(id: string): string {
  return id.slice(0, 8);
}
